import { Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { WttpQuestionResponseStatus } from 'src/graphql/generated/graphql';
import { Alert, Checked, Config, PlayerNext } from '@otp/icons';
import clsx from 'clsx';

type WttpQuestionnaireResponseQuestionStatusProps = {
  status?: WttpQuestionResponseStatus;
};

export const WttpQuestionnaireResponseQuestionStatus = ({
  status,
}: WttpQuestionnaireResponseQuestionStatusProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question-response.status',
  });

  switch (status) {
    case WttpQuestionResponseStatus.Fixed:
      return (
        <Status
          color="text-blue-600"
          text={t('fixed')}
          icon={<Config fill="blue" stroke-width={0} />}
        />
      );
    case WttpQuestionResponseStatus.Issue:
      return <Status color="text-red-600" text={t('issue')} icon={<Alert />} />;
    case WttpQuestionResponseStatus.Okay:
      return (
        <Status
          color="text-green-600"
          text={t('okay')}
          icon={<Checked fill="green" />}
        />
      );
    case WttpQuestionResponseStatus.Skipped:
      return (
        <Status
          color="text-gray-600"
          text={t('skipped')}
          icon={<PlayerNext />}
        />
      );
    default:
      return <Status color="text-gray-600" text={t('not-answered')} />;
  }
};

const Status = ({
  text,
  color,
  icon,
}: {
  text: string;
  color: string;
  icon?: React.ReactNode;
}) => (
  <div className={clsx(color, 'flex flex-row gap-1 items-center')}>
    <Typography variant="subtitle2" fontWeight="bold">
      {text.toUpperCase()}
    </Typography>
    {icon}
  </div>
);
